import { pilot } from '~/services/serviceInstances';
import { bytesToBlob } from '~/utils/files';

interface Request {
  attachmentId: string;
}

export const downloadAttachment = async (request: Request): Promise<Blob> => {
  const { attachmentId } = request;
  const config = { responseType: 'blob' as const };

  const response = await pilot.get(`/attachment/${attachmentId}`, config);
  return bytesToBlob(response.data, response.data.type);
};
